import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { TimePipe } from "./time.pipe";

const pipes = [TimePipe];
@NgModule({
  declarations: pipes,
  imports: [CommonModule],
  exports: pipes,
})
export class PipesModule {}
